import en from './settings.en';

const enConfig = { en };

export default enConfig;
